import SAApi from './_saApi';
import httpClient from '@/apis/base/httpclient';

class SAReturnAPI extends SAApi {
  constructor() {
    super();
  }
  controllerName = 'SAReturns';

  /**
   * Lấy dữ liệu cho màn hình chọn chứng từ mua, nhập VTHH nếu tính giá theo phương pháp đích danh
   * HQMINH 16.08.2022
   */
  async getReceiptSaleUnitCapitalList(payload) {
    let request = {
      url: this.getAPIUrl() + '/getReceiptSaleUnitCapitalList',
      data: payload,
    };

    return httpClient.getAsync(request);
  }
}

export default new SAReturnAPI();
